// extracted by mini-css-extract-plugin
export default {"footerMenu":"footerMenu__oj-CL","active":"active__2qiG9"};